export default {
  emailAutomation: {
    title: 'We just made it easier to get in touch with members',
    description:
      'Use pre-written, customizable and automated emails to send to current members or future members.'
  },
  inviteCustomers: {
    title: 'Import your customers now to join your rewards program!',
    description:
      'Once started, the import process will bring customers into your dashboard. After importing, you can create an email campaign that invites customers to join your program.'
  },
  socialRewards: {
    title: 'Get more followers on social by rewarding members with coins',
    description:
      'Why do all the work yourself when you can leverage the networks that already exist? Just make sure you are active on social media—nobody wants to follow a ghost town.'
  },
  referralProgram: {
    title: 'Reward your members and gain new ones',
    description:
      'Launching a referral program for your online loyalty widget means empowering existing members to invite people they know to connect with your business and buy.'
  },
  disclaimer:
    'Connect an online provider to set up this feature. Once done, your in-store members will no longer be rewarded.',
  button: 'Go to Integrations'
};
